import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-coral-300)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <path
    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20H4V12Z"
    fill={textColor}
  />
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <path
    d="M8.32007 15.9998C8.32007 11.7583 11.7585 8.31982 16.0001 8.31982C20.2416 8.31982 23.6801 11.7583 23.6801 15.9998C23.6801 20.2414 20.2416 23.6798 16.0001 23.6798H8.32007V15.9998Z"
    fill={textColor}
  />
);

export const OpenEndedIcon = createSlideIcon(Icon24x24, Icon32x32);
